export default class BackgroundVideo {


	// Constructor
	constructor(element) {
		this.element = element;
		this.parent = this.element.parentNode;
		this.video = this.element.querySelector('video');
	}


	// Public Methods
	resize() {
		if (!this.video) {
			return;
		}

		const vidWidth = this.video.videoWidth;
		const vidHeight = this.video.videoHeight;
		const vidRatio = vidWidth / vidHeight;

		const elmWidth = this.parent.offsetWidth;
		const elmHeight = this.parent.offsetHeight;
		const elmRatio = elmWidth / elmHeight;

		var newWidth = 0;
		var newHeight = 0;
		if (elmRatio > vidRatio) {
			newWidth = elmWidth;
			newHeight = (elmWidth / vidWidth) * vidHeight;
		} else {
			newWidth = (elmHeight / vidHeight) * vidWidth;
			newHeight = elmHeight;
		}

		this.element.style.width = newWidth + 'px';
		this.element.style.height = newHeight + 'px';
	}


}
